import { SelectionEntry } from "@app/components/core/SelectionEntry/SelectionEntry"
import { useGetStrings } from "@app/store/service/cmsService"
import { getPriceString } from "@app/utils/localeUtils"
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { classNamez } from "@tecreation/funnel-components"
import "./LoungerTypeSelector.css"

const LoungerTypeSelector = ({ imgSrc, persons, price, name, additionalInfo, onAdd, onRemove, count, disabled, expanded, plusDisabled }) => {
	const {
		data: { for: forString },
	} = useGetStrings(undefined, { defaultData: {} })
	return (
		<SelectionEntry
			imgSrc={imgSrc}
			count={count}
			onAdd={onAdd}
			onRemove={onRemove}
			disabled={disabled}
			expanded={expanded}
			plusDisabled={plusDisabled}
			isExpandable
			ariaLabel={name}
		>
			<div className="flex flex-items-center">
				{Array.apply(null, Array(persons)).map((e, i) => {
					return (
						<div className="p-1 color-bg-primary color-fg-on-primary f6 flex-shrink-0" key={i}>
							<FontAwesomeIcon icon={faUser} />
						</div>
					)
				})}
				<div className="ml-1">{name}</div>
			</div>
			<div className={"color-fg-secondary mt-1" + classNamez({ "color-fg-attention": !!additionalInfo })}>
				{additionalInfo && additionalInfo + ": "}
				{forString} {getPriceString(price)}
			</div>
		</SelectionEntry>
	)
}

export { LoungerTypeSelector }
